import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { GlobalStyles } from "./styles/GlobalStyles";
import { AuthProvider } from "./contexts/AuthContext";
import { GlobalSettingsProvider } from "./contexts/GlobalSettingsContext";
import Layout from "./components/Layout/Layout";
import PrivateRoute from "./components/Auth/PrivateRoute";
import Blog from "./pages/Blog";
import About from "./pages/About";
import Briefly from "./pages/Briefly";
import BlogPost from "./components/Blog/BlogPost";
import NewPost from "./pages/Admin/NewPost";
import Login from "./pages/Login";
import TempImport from "./pages/Admin/TempImport";
import CursorEffect from "./components/common/CursorEffect";

function App() {
  return (
    <Router>
      <GlobalSettingsProvider>
        <AuthProvider>
          <GlobalStyles />
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 4000,
              style: {
                background: "#333",
                color: "#fff",
              },
            }}
          />
          <CursorEffect />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Blog />} />
                    <Route path="/blog/:id" element={<BlogPost />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/briefly" element={<Briefly />} />
                    <Route
                      path="/admin/new-post"
                      element={
                        <PrivateRoute>
                          <NewPost />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/admin/edit/:id"
                      element={
                        <PrivateRoute>
                          <NewPost />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/admin/import"
                      element={
                        <PrivateRoute>
                          <TempImport />
                        </PrivateRoute>
                      }
                    />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </AuthProvider>
      </GlobalSettingsProvider>
    </Router>
  );
}

export default App;
